import { Wifi, WifiOff } from "lucide-react";
import { useEffect, useState } from "react";
import { useNetworkStore } from "@/store/network";

export function ConnectionBanner() {
  const { isOnline, wasOffline, markOfflineWarningDismissed } = useNetworkStore();
  const [showRecovered, setShowRecovered] = useState(false);

  useEffect(() => {
    if (isOnline && wasOffline) {
      // Internet came back after being offline - show recovery indicator briefly
      setShowRecovered(true);
      const timer = setTimeout(() => {
        setShowRecovered(false);
        markOfflineWarningDismissed();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline, markOfflineWarningDismissed]);

  if (isOnline && !showRecovered) return null;

  return (
    <div
      className={`z-[60] shrink-0 border-b px-4 py-3 text-sm font-medium text-white shadow-lg transition-all duration-300 ${
        isOnline ? "border-emerald-500/30 bg-emerald-600" : "border-amber-500/30 bg-amber-600"
      }`}
    >
      <div className="flex items-center justify-center gap-3">
        {isOnline ? (
          <>
            <Wifi className="h-5 w-5" />
            <span>Internet bağlantısı yeniden sağlandı. Devam edebilirsiniz.</span>
          </>
        ) : (
          <>
            <WifiOff className="h-5 w-5 animate-pulse" />
            <span>
              Internet bağlantısı kesildi. Bağlantı sağlandığında otomatik olarak devam edilecektir.
            </span>
          </>
        )}
      </div>
    </div>
  );
}
